import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import Breadcrumb from 'components/layout/Breadcrumb';

import { ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_CRM_MASTER, ROLE_EMPLOYEE } from 'js/constants';
import may from 'js/security';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';
import {ROLE_ROOT_EMPLOYEE, ROLE_DIRECT_CUSTOMER} from "../../../constants";

class SettingsIndex extends React.Component {
  getGroups = () => {
    const {
      intl: { messages },
    } = this.props;

    const allGroups = [
      { title: messages.my_company, key: 'self' },
      { title: messages.user_administration, key: 'users' },
      { title: messages.client_administration, key: 'contact' },
      { title: messages.crm_administraion, key: 'crm' },
      { title: messages.content_administration, key: 'content' },
      { title: messages.product_administration, key: 'products' },
      { title: messages.car_service_administration, key: 'carService' },
      { title: messages.site_administration, key: 'admin' },
      { title: messages.commission_provision, key: 'commission' },
      { title: messages.subscription_plan, key: 'subscriptions' },
      { title: messages.update_notification, key: 'updates' },
    ];

    const result = [];
    for (let i = 0; i < allGroups.length; i++) {
      const settings = this.getSettings(allGroups[i].key);

      if (settings.length) {
        result.push({
          title: allGroups[i].title,
          key: allGroups[i].key,
          settings,
        });
      }
    }

    return result;
  };

  getSettings = type => {
    const {
      intl: { messages },
      appIntl: { urlPrefix },
      user,
    } = this.props;

    const allSettings = {
      self: [],
      users: [],
      contact: [],
      crm: [],
      content: [],
      products: [],
      carService: [],
      admin: [],
      commission: [],
      subscriptions: [],
      updates: [],
    };

    const showElement = false; // to hide elements

    if (may(ROLE_ADMIN, user.roles) && may(ROLE_EMPLOYEE, user.roles)) {
      allSettings.self.push({
        title: messages.my_company,
        description: messages.edit_your_company_data,
        url: urlPrefix + 'account/settings/myCompany',
        icon: 'far fa-building',
      });
    }
    allSettings.self.push({
      title: messages.profile,
      description: messages.profile_information_avatar_contact_address,
      url: urlPrefix + 'account/settings/profile',
      icon: 'far fa-user',
    });
    if (may(ROLE_SUPERADMIN, user.roles) && showElement) {
      allSettings.self.push({
        title: messages.locations,
        description: messages.define_sales_points_address_position_map_opening_hours,
        url: urlPrefix + 'account/settings/locations',
        icon: 'far fa-map',
      });
    }
    if (may(ROLE_EMPLOYEE, user.roles)) {
      allSettings.self.push({
        title: messages.salesDoc.invoices,
        description: messages.check_incoming_and_outgoing_invoices_check_details_and_download_as_pdf,
        url: urlPrefix + 'account/settings/invoices',
        icon: 'far fa-file',
      });
      allSettings.contact.push({
        title: messages.clients,
        description: '',
        url: urlPrefix + 'account/clients',
        icon: 'far fa-male',
      });
      allSettings.contact.push({
        title: messages.contact,
        description: '',
        url: urlPrefix + 'account/contact-management',
        icon: 'far fa-address-book',
      });
      allSettings.self.push({
        title: messages.orders,
        description: '',
        url: urlPrefix + 'account/orders',
        icon: 'far fa-shopping-bag',
      });
      allSettings.self.push({
        title: messages.tasks,
        description: '',
        url: urlPrefix + 'account/tasks',
        icon: 'far fa-tasks',
      });
      allSettings.self.push({
        title: messages.campaign.sidebar,
        description: '',
        url: urlPrefix + 'account/campaigns',
        icon: 'far fa-map',
      });
    }

    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      allSettings.self.push({
        title: messages.white_label_projects,
        description: messages.projects_running_on_different_domains,
        url: urlPrefix + 'account/settings/whiteLabel',
        icon: 'fa fa-asterisk',
      });
      allSettings.self.push({
        title: 'WhiteLabel '+messages.plugins,
        description: messages.enhance_your_project_with_plugins,
        url: urlPrefix + 'account/settings/whiteLabelPlugin',
        icon: 'fa fa-plug',
      });
      allSettings.self.push({
        title: messages.plugins,
        description: messages.enhance_your_project_with_plugins,
        url: urlPrefix + 'account/settings/plugins',
        icon: 'fa fa-plug',
      });
      if (showElement) {
        allSettings.self.push({
          title: messages.communities,
          description: messages.gain_coverage_with_community,
          url: urlPrefix + 'account/settings/communities',
          icon: 'fad fa-project-diagram',
        });
      }
      allSettings.updates.push({
        title: messages.update_notification,
        description: messages.update_notification_settings_description,
        url: urlPrefix + 'account/settings/updates',
        icon: 'fad fa-lightbulb-exclamation',
      });
    }

    if (
      may('ROLE_HR_FINANCIAL', user.roles) ||
      may('ROLE_HR_PROFILE', user.roles) ||
      may('ROLE_HR_PASSWORD', user.roles) ||
      may('ROLE_HR_ROLES', user.roles) ||
      may('ROLE_HR_TEAMS', user.roles)
    ) {
      allSettings.users.push({
        title: messages.users,
        description: messages.create_users_manage_profile_financial_roles_teams,
        url: urlPrefix + 'account/settings/users',
        icon: 'fa fa-id-badge',
      });
    }
    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      allSettings.users.push({
        title: messages.import_users,
        description: messages.import_users_via_csv,
        url: urlPrefix + 'account/settings/usersimport',
        icon: 'fal fa-user-plus',
      });
    }
    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      allSettings.users.push({
        title: messages.remove_users,
        description: messages.remove_users_via_csv,
        url: urlPrefix + 'account/settings/usersremove',
        icon: 'fal fa-user-minus',
      });
    }
    if (may('ROLE_HR_TEAMS', user.roles)) {
      allSettings.users.push({
        title: messages.teams,
        description: messages.create_update_teams_assign_system_types,
        url: urlPrefix + 'account/settings/teams',
        icon: 'fa fa-users',
      });
    }

    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      // @todo: for ROLE_CRM_MASTER
      if (showElement) {
        allSettings.crm.push({
          title: messages.questionnaires,
          description: messages.create_questionnaires_for_workflows_and_campaigns,
          url: urlPrefix + 'account/settings/questionnaires',
          icon: 'fa fa-list-ul',
        });
      }
      if (showElement) {
        allSettings.crm.push({
          title: messages.document_types,
          description: messages.create_document_types_use_for_process_automation,
          url: urlPrefix + 'account/settings/docTypes',
          icon: 'fa fa-list-alt',
        });
      }
      if (showElement) {
        allSettings.crm.push({
          title: messages.document_templates,
          description: messages.code_document_templates_for_print_use_the_templates_for_individual_quotes_and_invoices,
          url: urlPrefix + 'account/settings/docTemplates',
          icon: 'fal fa-file-code',
        });
      }
      allSettings.crm.push({
        title: messages.pipelines,
        description: messages.define_manage_pipelines_and_stages,
        url: urlPrefix + 'account/settings/pipelines',
        icon: 'fa fa-tasks',
      });
      if (showElement) {
        allSettings.crm.push({
          title: messages.lead_autoresponse,
          description: messages.automatically_respond_to_incoming_leads,
          url: urlPrefix + 'account/settings/autoresponses',
          icon: 'fal fa-reply-all',
        });
      }
      allSettings.crm.push({
        title: messages.escalation_rules,
        description: messages.define_rules_when_you_would_like_to_inform_users_about_overdue_leads,
        url: urlPrefix + 'account/settings/escalationRules',
        icon: 'fal fa-lightbulb-exclamation',
      });
      allSettings.content.push({
        title: messages.email_templates,
        description: messages.write_email_templates_send_to_clients,
        url: urlPrefix + 'account/settings/templates',
        icon: 'far fa-envelope',
      });
      allSettings.content.push({
        title: messages.cms_elements,
        description: messages.define_reusable_cms_elements,
        url: urlPrefix + 'account/settings/cmsElements',
        icon: 'fa fa-desktop',
      });
      allSettings.content.push({
        title: messages.cms_templates,
        description: messages.define_custom_page_templates_to_meet_your_cd,
        url: urlPrefix + 'account/settings/cmsTemplates',
        icon: 'fal fa-shapes',
      });
      allSettings.products.push({
        title: messages.categories,
        description: messages.display_and_manage_category_tree,
        url: urlPrefix + 'account/settings/categories',
        icon: 'fa fa-map-signs',
      });
      allSettings.products.push({
        title: messages.products,
        description: messages.display_and_manage_products,
        url: urlPrefix + 'account/items',
        icon: 'fa fa-map-signs',
      });
      allSettings.products.push({
        title: messages.product_groups,
        description: messages.product_groups_description,
        url: urlPrefix + 'account/settings/productgroups',
        icon: 'fa fa-map-signs',
      });
      allSettings.products.push({
        title: messages.producttemplates,
        description: messages.display_and_manage_product_templates,
        url: urlPrefix + 'account/settings/producttemplates',
        icon: 'fa fa-book-dead',
      });
      allSettings.products.push({
        title: messages.archived_product_templates,
        description: messages.archived_product_templates_description,
        url: urlPrefix + 'account/settings/archivedproducttemplates',
        icon: 'fa fa-book-dead',
      });
      allSettings.products.push({
        title: messages.attributes,
        description: messages.define_product_attributes_search_and_variants,
        url: urlPrefix + 'account/settings/attributes',
        icon: 'fa fa-tags',
      });
      allSettings.products.push({
        title: messages.attribute_groups,
        description: messages.group_attributes_to_better_manage_and_inform,
        url: urlPrefix + 'account/settings/attributeGroups',
        icon: 'fa fa-tags',
      });
    }
    if (may('ROLE_USER' , user.roles) && !may(ROLE_DIRECT_CUSTOMER , user.roles)) {
      allSettings.products.push({
        title: messages.coupons,
        description: messages.create_discounts_and_subsidy_products,
        url: urlPrefix + 'account/settings/coupons',
        icon: 'fal fa-badge-percent',
      });
    }

    if (may(ROLE_SUPERADMIN, user.roles) && showElement) {
      // @TODO: for ROLE_ADMIN
      allSettings.admin.push({
        title: messages.dynamic_data_definitions,
        description: messages.entity_fields_missing_add_new,
        url: urlPrefix + 'account/settings/dataDefinitions',
        icon: 'far fa-folder-open',
      });
    }
    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      if (showElement) {
        allSettings.admin.push({
          title: messages.integrations,
          description: messages.found_api_interesting_personal_api_key_here,
          url: urlPrefix + 'account/settings/integrations',
          icon: 'fa fa-bolt',
        });
      }
      if (showElement) {
        allSettings.admin.push({
          title: messages.data_push,
          description: messages.need_our_data_in_own_system_configure_data_push,
          url: urlPrefix + 'account/settings/dataPush',
          icon: 'fa fa-arrow-circle-right',
        });
      }
      if (showElement) {
        allSettings.admin.push({
          title: messages.lead_catchers,
          description: messages.catch_leads_from_other_sources_with_custom_email,
          url: urlPrefix + 'account/settings/leadCatchers',
          icon: 'fas fa-level-down-alt',
        });
      }
      if (showElement) {
        allSettings.admin.push({
          title: messages.lead_taggers,
          description: messages.tag_leads_with_custom_regular_expressions,
          url: urlPrefix + 'account/settings/leadTaggers',
          icon: 'fal fa-hashtag',
        });
      }
    }
    if (may(ROLE_SUPERADMIN, user.roles)) {
      allSettings.admin.push({
        title: messages.white_label_plugins,
        description: messages.enhance_chedri_project_with_plugins,
        url: urlPrefix + 'account/settings/whiteLabelPlugin',
        icon: 'fa fa-plug',
      });
      allSettings.admin.push({
        title: messages.allowed_domains_title,
        description: messages.d,
        url: urlPrefix + 'account/settings/allowedDomains',
        icon: 'fas fa-tasks',
      });
    }
    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      allSettings.admin.push({
        title: messages.lead_per_mail,
        description: messages.create_rules_to_forward_emails,
        url: urlPrefix + 'account/settings/leadPerMailRules',
        icon: 'fal fa-forward',
      });
      allSettings.admin.push({
        title: messages.lead_assignment_strategies,
        description: messages.change_the_lead_assignment_strategies_for_companies_and_pipelines,
        url: urlPrefix + 'account/settings/leadAssignmentStrategies',
        icon: 'far fa-user-check',
      });
      allSettings.admin.push({
        title: messages.failed_refunds,
        description: messages.list_all_failed_refund_payments,
        url: urlPrefix + 'account/settings/failedRefunds',
        icon: 'fal fa-times-circle',
      });
      allSettings.admin.push({
        title: messages.main_menu_versions,
        description: messages.administration_of_main_menu_versions,
        url: urlPrefix + 'account/settings/mainMenuVersions',
        icon: 'fal fa-directions',
      });
      // Service type commissions
      allSettings.commission.push({
        title: messages.provision_service,
        description: messages.provision_service_description,
        url: urlPrefix + 'account/settings/serviceTypes',
        icon: 'fad fa-concierge-bell',
      });
      // Commission service logs
      allSettings.commission.push({
        title: messages.provision_service_documents,
        description: messages.provision_service_documents_description,
        url: urlPrefix + 'account/settings/provisionService',
        icon: 'fad fa-concierge-bell',
      });
      // Monthly commission documents
      allSettings.commission.push({
        title: messages.commission_service_documents,
        description: messages.commission_service_documents_description,
        url: urlPrefix + 'account/settings/commissionServiceInvoices',
        icon: 'fad fa-concierge-bell',
      });

      // Subscriptions
      if (may('ROLE_ADMIN' , user.roles) && !may(ROLE_DIRECT_CUSTOMER , user.roles)) {
        allSettings.subscriptions.push({
          title: messages.subscription_settings,
          description: messages.subscription_settings_description,
          url: urlPrefix + 'account/settings/subscriptions',
          icon: 'fad fa-repeat-alt',
        });
      }

      // Subscriptions configuration to the item or client.
      if (may('ROLE_ADMIN', user.roles) && !may(ROLE_DIRECT_CUSTOMER , user.roles)) {
        allSettings.subscriptions.push({
          title: messages.client_subscription_settings,
          description: messages.client_subscription_settings_description,
          url: urlPrefix + 'account/settings/clientsubscriptions',
          icon: 'fad fa-repeat-alt',
        });
      }


    }
    if (may(ROLE_DIRECT_CUSTOMER, user.roles)) {
      allSettings.self.push({
        title: messages.orders,
        description: '',
        url: urlPrefix + 'account/orders',
        icon: 'far fa-shopping-bag',
      });
      allSettings.self.push({
        title: messages.campaign.sidebar,
        description: '',
        url: urlPrefix + 'account/campaigns',
        icon: 'far fa-map',
      });
      allSettings.self.push({
        title: messages.salesDoc.invoices,
        description: messages.check_incoming_and_outgoing_invoices_check_details_and_download_as_pdf,
        url: urlPrefix + 'account/settings/invoices',
        icon: 'far fa-file',
      });
      allSettings.self.push({
        title: messages.media_library,
        description: messages.upload_and_manage_media_files,
        url: urlPrefix + 'account/media',
        icon: 'far fa-photo-video',
      });

    }

    return allSettings[type];
  };

  getBox = (title, description, url, icon) => {
    const { layout, history } = this.props;

    let iconElement;
    let iconElementSlide;
    if (icon) {
      iconElement = <i className={'hidden-xs fa-4x ' + icon} />;
      iconElementSlide = <i className={'hidden-xs text-primary fa-4x ' + icon} />;
    }

    return (
      <div
        className={
          (layout.breakpointIndex !== 0 ? 'widget-8 ' : '') +
          'settings panel no-border no-margin widget-loader-bar p-t-20'
        }
        style={{ cursor: 'pointer' }}
        onClick={() => {
          history.push(url);
        }}
      >
        <div className="container-xs-height full-height">
          <div className="row-xs-height">
            <div className="col-xs-height col-top">
              <Col xs={10}>
                <p className="fs-16 text-black">
                  <i className={'hidden-sm hidden-md hidden-lg m-r-5 fa-fw ' + icon} /> {title}
                </p>
                <p className="small hint-text">{description}</p>
              </Col>

              <div className="icon">{iconElement}</div>

              <div className="icon-slide">{iconElementSlide}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      intl: { messages },
      appIntl,
    } = this.props;

    return (
      <DocMeta tags={generateMetaTags(messages.meta.settings)}>
        <div className="container-fluid padding-25 sm-padding-10">
          <Breadcrumb
            crumbs={[
              { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
              { link: null, name: messages.settings },
            ]}
            className="p-t-0"
          />

          {this.getGroups().map(group => {
            return (
              <div key={group.key}>
                <div className="font-secondary fs-11 all-caps bold" style={{ padding: '20px 0 7px 15px' }}>
                  {group.title}
                </div>
                <Row>
                  {group.settings.map((settings, i) => {
                    return (
                      <Col xs={12} sm={6} md={4} lg={3} className="m-b-10" key={i}>
                        {this.getBox(settings.title, settings.description, settings.url, settings.icon)}
                      </Col>
                    );
                  })}
                </Row>
              </div>
            );
          })}
        </div>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    appIntl: state.intl,
    layout: state.layout,
    projectConfig: state.data.projectConfig,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(SettingsIndex)));
